<template>
  <div :class="{'app': true, 'active': is_active}">
    <Loader v-if="is_loading"/>
    <template>
      <template v-if="local_steps.length > 0" v-for="(step, key) in local_steps">
        <ElementStart
            :step="step"
            :current-step="getCurrentStep(key)"
            :key="key"
            v-if="step && step.step_type === 'start' && current_step == key"
        />

        <ElementText
            :step="step"
            :current-step="getCurrentStep(key)"
            :key="key"
            v-if="step && step.step_type === 'text' && current_step == key"
        />

        <ElementSelect
            :step="step"
            :steps="local_steps"
            :current-step="getCurrentStep(key)"
            :max-steps="max_step"
            :key="key"
            v-if="step && step.step_type === 'step' && (current_step == key || current_step > 1)"
        />

        <ElementProduct
            :step="step"
            :steps="local_steps"
            :current-step="getCurrentStep(key)"
            :max-steps="max_step"
            :key="key"
            :path="path"
            v-if="step && step.step_type === 'product'"
        />

        <ElementProductCompare
            :step="step"
            :steps="local_steps"
            :current-step="getCurrentStep(key)"
            :max-steps="max_step"
            :key="key"
            :path="path"
            v-if="step && step.step_type === 'product-compare'"
        />
      </template>


    </template>

  </div>
</template>

<script>
import ElementStart from './Steps/ElementStart.vue';
import ElementText from './Steps/ElementText.vue'
import ElementSelect from './Steps/ElementSelect.vue'
import ElementProduct from './Steps/ElementProduct.vue'
import Loader from './Parts/Loader.vue'
import axios from 'axios';
import EventBus from "../event-bus";
import ElementProductCompare from "./Steps/ElementProductCompare.vue";

export default {
    name: 'Configurator',
    props: [
      'restUrlProduct',
      'restUrlProducts',
      'restUrlSteps',
      'restUrlSettings'
    ],
    components: {
      ElementProductCompare,
      ElementStart,
      ElementText,
      ElementSelect,
      ElementProduct,
      Loader
    },
    data: () => ({
      is_loading: false,
      is_active: false,
      current_step: 0,
      actual_step: 0,
      max_step: 0,
      path: [],
      local_steps: [],
      global_steps: [],
    }),
    mounted() {
      this.getSteps();
      this.setEvents();

      EventBus.$on('SET_STEP', (payLoad) => {
        this.current_step = payLoad;
      });

      EventBus.$on('SET_NEXT_STEP', (payLoad) => {
        const global = this.global_steps[2]['selects'];
        let local = [];
        this.local_steps = [];

        this.path.forEach((index, key) => {
          if (key === 0) {
            local = global[index].children;
          } else {
            local = local.selects[index].children;
          }
        });

        this.local_steps.push(local);
      });

      EventBus.$on('SET_START', (payLoad) => {
        this.current_step = 0;
        this.path = [];
        this.local_steps = this.global_steps;
      });

      EventBus.$on('SET_PATH', (payLoad) => {
        this.path.push(payLoad.index);
      });

      EventBus.$on('CLOSE_APP', (payLoad) => {
        document.querySelector('body').removeClass('overflow-hidden')
        this.is_active = false;
      });

      EventBus.$on('OPEN_APP', (payLoad) => {
        document.querySelector('body').addClass('overflow-hidden')
        this.is_active = true;
      });

      EventBus.$on('SET_LOADER', (payLoad) => {
        this.is_loading = payLoad;
      });
    },
    methods: {
      setEvents() {
        window.addEventListener('open_app', () => {
          document.querySelector('body').addClass('overflow-hidden');
          this.current_step = 0;
          this.is_active = true;
        });

        window.addEventListener('close_app', () => {
          document.querySelector('body').removeClass('overflow-hidden');
          this.is_active = false;
        });
      },
      getCurrentStep(key) {
        return key;
      },
      setMaxStep() {
        // this.max_step = this.local_steps.filter((el) => {
        //   return el.step_type === 'select'
        // }).length + this.local_steps.filter((el) => {
        //   return el.step_type === 'product'
        // }).length;
      },
      async getSteps() {
        this.is_loading = true;

        await axios.post(this.restUrlSteps)
          .then((response) => {
            this.local_steps = response.data;
            this.global_steps = response.data;
            this.setMaxStep();
            this.is_loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>
